/**
 * Native replacement for lodash/fp `debounce` (trailing edge). Returns a
 * debounced version of `fn` that delays invocation until `wait` ms have elapsed
 * since the last call, invoking with the most recent arguments and `this`.
 *
 * Note the argument order differs from lodash/fp's curried `debounce(wait, fn)`.
 */
export default function debounce<A extends unknown[]>(fn: (...args: A) => void, wait: number): (...args: A) => void {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    return function debounced(this: unknown, ...args: A) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), wait);
    };
}
